<template lang="html">
    <div class="gosuhu">
        <secondary-header title="Check In" backRoute="default">
            <template v-slot:menu>
                <div class="main-menu text-only">
                    <ul class="nav nav-pills nav-fill container">
                        <li class="nav-item">
                            <router-link :to="{ name: 'history' }" class="nav-item" replace exact>
                                <span> {{ lang('History') }}</span>
                            </router-link>
                        </li>
                        <li class="nav-item">
                            <router-link :to="{ name: 'merchant' }" class="nav-item" replace>
                                <span> {{ lang('Merchant') }}</span>
                            </router-link>
                        </li>
                    </ul>
                </div>
            </template>
        </secondary-header>

        <main>
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-md-10">
                        <div class="content pt-4">

                            <router-view></router-view>

                        </div>
                    </div>
                </div>
            </div>
        </main>

        <main-footer></main-footer>
    </div>
</template>

<script>
export default {
}
</script>

<style lang="scss" scoped>
    .nav-item:not(:last-child) {
        border-right: 1px solid #e3e3e3;
    }
</style>
